<template>
  <div>
    <div class="relative overflow-hidden">
      <div class="py-8 sm:py-16">

        <Container>
          <div class="md:grid md:grid-cols-12 lg:grid-cols-12">
            <div class="md:col-start-2 md:col-span-10 lg:col-start-2 lg:col-span-8 relative">
              <FadeIn>
                <div 
                v-if="content.categories || content.date"
                class="tag-list tag-list--blog"
                >
                  <time v-if="content.date" :datetime="content.date" class="text-gray-500">{{ useFormattedDate(content.date) }}<template v-if="content.time">, {{ content.time }} {{ useAustralianTimezone(content.date) }}</template></time>
                </div>
                <h1 class="blog-h1">
                  {{ content.title }}
                </h1>
                <div class="mt-4">
                  <template v-if="content.categories">
                    <ElementTag v-for="(cat, catIndex) in content.categories.filter(c => c && c.category_id)" :key="catIndex" :tag="cat.category_id" />
                  </template>
                </div>
                <div class="blog-subtitle" v-html="content.subtitle" v-interpolation></div>
              </FadeIn>
            </div>
          </div>
        </Container>

      </div>

      <div class="relative" v-if="content?.image?.id">
        <div class="absolute inset-0 flex flex-col">
          <div class="flex-1" />
          <div class="w-full flex-1 bg-faun" />
        </div>
        <Container class="relative">
          <FadeIn>
            <ImageResponsive
            classes="rounded-[20px] lg:rounded-[35px]"
            :data="content?.image"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            priority="high"
            />
          </FadeIn>
        </Container>
      </div>
    </div>

  </div>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

</script>